const TypingIndicator = ({ userIds, typingUsersList2 }) => {
  if (!userIds || userIds.length === 0) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "8px 4px",
        marginLeft: "40px",
      }}
    >
      <div style={{ display: "flex", gap: "3px" }}>
        <div
          style={{
            width: "6px",
            height: "6px",
            backgroundColor: "#6b7280",
            borderRadius: "50%",
            animation: "typing-bounce 1.4s infinite ease-in-out both",
            animationDelay: "0ms",
          }}
        />
        <div
          style={{
            width: "6px",
            height: "6px",
            backgroundColor: "#6b7280",
            borderRadius: "50%",
            animation: "typing-bounce 1.4s infinite ease-in-out both",
            animationDelay: "160ms",
          }}
        />
        <div
          style={{
            width: "6px",
            height: "6px",
            backgroundColor: "#6b7280",
            borderRadius: "50%",
            animation: "typing-bounce 1.4s infinite ease-in-out both",
            animationDelay: "320ms",
          }}
        />
      </div>
      <span style={{ color: "#6b7280", fontSize: "12px" }}>
        {typingUsersList2[0]?.name || "Someone"} is typing...
      </span>
    </div>
  );
};

export default TypingIndicator;
